<template>
     <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="item in dataList" :key="item.label">
               <a v-if="item.path" :href="item.path">{{ item.label }}</a>
               <template v-else>{{ item.label }}</template>
          </el-breadcrumb-item>
     </el-breadcrumb>
</template>

<script>
export default {
     props:{
          dataList:{
               type:Array,
               default:()=>JSON.parse(JSON.stringify([]))
          }
     },
     
     data() {
          return {

          }
     },
}
</script>

<style lang="scss" scoped>
::v-deep .el-breadcrumb__item {
     .el-breadcrumb__separator {
          font-weight: normal;
     }

     a {
          font-weight: normal;
          color: #222;
     }
}
</style>